function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Window_open"
}, /*#__PURE__*/React.createElement("title", null, "VF_window_open_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 14.2H0v255.1h283.5V14.2zM28.3 49.6l70.9 30.6v123l-70.9 30.6V49.6zm99.3 170.1V63.8L83.2 42.5h117l-44.3 21.3v155.9l44.3 21.3h-117l44.4-21.3zm56.7-16.5v-123l70.9-30.6v184.3l-70.9-30.7z"
}))));